const MAIN_DOMAIN = 'geeksoft.kz'

export const REQUEST_URL = `https://platform-back.${MAIN_DOMAIN}`
// export const REQUEST_URL = `http://localhost:8085`

export const LoggerURL = 'https://easylogging.prodengi.kz'
export const AuthorizationLogger = '~Kpe@imrcdtT2m~|zOmto%nw1$8j4N5zS?WXU8@6ZZ~R2Tg7oQ'
export const STORAGE_DOMAIN = MAIN_DOMAIN



// WEBPACK FOOTER //
// /src/_config.js